import React, { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import './PaymentPages.css';

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');
    const orderId = searchParams.get('orderId');
    const sessionId = searchParams.get('session_id');
    const { clearCart } = useCart();

    useEffect(() => {
        if (type === 'store') {
            clearCart();
        }
    }, [type, clearCart]);

    useEffect(() => {
        // Here we could call an API to verify the session if we wanted immediate feedback,
        // but the webhook will handle the ticket generation.
    }, [sessionId]);

    const isStore = type === 'store';

    return (
        <div className="payment-page-wrapper">
            <div className="payment-card success">
                <div className="icon-circle">
                    <i className="fas fa-check"></i>
                </div>
                {isStore ? (
                    <>
                        <h1>Encomenda Registada!</h1>
                        <p>O seu pagamento foi efetuado com sucesso.</p>
                        <p className="note">
                            A sua encomenda foi criada e está a ser processada.
                            Enviámos uma confirmação para o seu email.
                        </p>
                        <div className="actions">
                            <Link to="/loja" className="btn-primary">Voltar à Loja</Link>
                        </div>
                    </>
                ) : (
                    <>
                        <h1>Pagamento Concluído!</h1>
                        <p>O seu bilhete foi gerado com sucesso e enviado para o seu email.</p>
                        <p className="note">Por favor, verifique a sua caixa de entrada (e a pasta de spam).</p>
                        <div className="actions">
                            <Link to="/dashboard-atleta" className="btn-primary">Voltar ao Dashboard</Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PaymentSuccess;
